import { Form, Formik } from "formik";
import { Button, Card, CardBody, FormGroup, Input, Label } from "reactstrap";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import { useGebruikerContext } from "../../Context/GebruikerContext";
import { useAlgemeenContext } from "./Context/AlgemenContext";

const PersonalDetails = () => {
	const { userDetails: data, currentUser, disable } = useGebruikerContext();
	const { errorField, handleFieldChange, handleSave } = useAlgemeenContext();

	const defaultValues = {
		vFirstName: data?.firstName || "",
		vMiddleName: data?.vMiddleName || "",
		vLastName: data?.vLastName || "",
		tAddress: data?.tAddress || "",
		vPostCode: data?.vPostCode || "",
		vCity: data?.vCity || "",
		vCountry: data?.vCountry || "",
		vSex: data?.vSex || "",
		dBirthdate:
			data?.dBirthdate && data?.dBirthdate !== "Invalid Da"
				? moment(data?.dBirthdate, "YYYY-MM-DD").toDate()
				: null,
	};

	return (
		<Card className="no-shadow">
			<CardBody className="d-flex flex-column card-padding">
				<h5 className="mb-4">Persoonsgegevens</h5>
				<Formik enableReinitialize initialValues={defaultValues} onSubmit={(values) => {
					
					handleSave(values);
				}}>
					{({ values, setFieldValue, handleChange }) => (
						<Form>
							<FormGroup
								className={`form-element ${errorField === "vFirstName" ? "error" : ""
									}`}
							>
								<Label>Clooser ID</Label>
								<h6 className="mb-0">{currentUser?.data?.clooserId}</h6>
							</FormGroup>
							<FormGroup
								className={`form-element ${errorField === "vFirstName" ? "error" : ""
									}`}
							>
								<Label for="vFirstName">Voornaam</Label>
								<Input
									name="vFirstName"
									type="text"
									value={values.vFirstName}
									onChange={handleChange}
									disabled={disable}
									maxLength={30}
								/>
							</FormGroup>
							<FormGroup
								className={`form-element ${errorField === "vMiddleName" ? "error" : ""
									}`}
							>
								<Label for="vMiddleName">Tussenvoegsel</Label>
								<Input
									name="vMiddleName"
									type="text"
									value={values.vMiddleName}
									onChange={handleChange}
									disabled={disable}
									 maxLength={30}
								/>
							</FormGroup>
							<FormGroup
								className={`form-element ${errorField === "vLastName" ? "error" : ""
									}`}
							>
								<Label for="vLastName">Achternaam</Label>
								<Input
									name="vLastName"
									type="text"
									value={values.vLastName}
									onChange={handleChange}
									disabled={disable}
									maxLength={30}
								/>
							</FormGroup>
							<FormGroup
								className={`form-element ${errorField === "vSex" ? "error" : ""}`}
							>
								<Label for="vSex">Geslacht</Label>
								<select
									className="form-select"
									name="vSex"
									value={values.vSex}
									onChange={handleChange}
									disabled={disable}
								>
									<option value="">Kies geslacht</option>
									<option value="Man">Man</option>
									<option value="Female">Vrouw</option>
								</select>
							</FormGroup>
							<FormGroup
								className={`form-element ${errorField === "dBirthdate" ? "error" : ""
									}`}
							>
								<Label for="dBirthdate">Geboortedatum</Label>
								<DatePicker
									selected={values.dBirthdate}
									onChange={(date) => {
										setFieldValue("dBirthdate", date);
									}}
									placeholderText={"dd-mm-jjjj"}
									locale="nl"
									dateFormat="dd-MM-yyyy"
									className="form-control"
									disabled={disable}
								/>
							</FormGroup>
							<div className="d-flex justify-content-end">
								<Button outline
									className="btn-outline-primary-blue btn-color-style py-2 px-3 d-flex gap-2 align-items-center mt-2"
									type="submit">
									Opslaan
								</Button>
							</div>
						</Form>

					)}
				</Formik>
			</CardBody>
		</Card>
	);
};

export default PersonalDetails;
